<template>
  <div
    class="switch-button"
    :class="switchButtonClasses"
  >
    <span class="text">Depressiemodus</span>
    <span class="span left">
      Uit
    </span>
    <button
      class="button"
      @click="$emit('toggle')"
    ></button>
    <span class="span right">
      Aan
    </span>
  </div>
</template>

<script>
export default {
  name: 'SwitchButton',
  props: {
    depressed: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    switchButtonClasses () {
      return {
        'depressed': this.depressed,
        'normal': !this.depressed
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.switch-button {
  width: 100%;
  position: absolute;
  z-index: 40;
  font-size: 0;
  bottom: 35px;
  left: 0;
  right: 0;
}
.text {
  border-radius: 18px;
  color: white;
  background-color: rgba(0, 0, 0, 0.8);
  position: absolute;
  bottom: 63px;
  left: 0;
  right: 0;
  margin: 0 auto;
  text-align: center;
  z-index: 10;
  width: 170px;
  line-height: 1;
  font-size: 18px;
  padding: 8px 0 10px;
}
.span {
  font-size: 18px;
  z-index: 10;
  color: white;
  position: absolute;
  width: 50%;
  bottom: 5px;
}
.left {
  left: 0;
}
.right {
  right: 0;
}

@keyframes pulse {
  0% {
    box-shadow: 0 0 0 0 rgba($c-red, 0.8);
  }
  70% {
    box-shadow: 0 0 0 25px rgba($c-red, 0);
  }
  100% {
    box-shadow: 0 0 0 0 rgba($c-red, 0);
  }
}

.button {
  height: 31px;
  width: 51px;
  background-color: $c-red;
  position: relative;
  border-radius: 15.5px;
  border: none;
  outline: 0;
  cursor: pointer;
  z-index: 20;
  padding: 0;
  margin: 0;
  transition: background-color 0.2s ease;
  will-change: background-color;

  &:before {
    content: '';
    background-color: white;
    width: 27px;
    height: 27px;
    border-radius: 50%;
    border: 0.5px solid rgba(0, 0, 0, 0.1);
    box-shadow: 0px 3px 1px 0px rgba(0, 0, 0, 0.05), 0px 2px 2px 0px rgba(0, 0, 0, 0.1), 0px 3px 3px 0px rgba(0, 0, 0, 0.05);
    position: absolute;
    top: 2px;
    left: 2px;
    transform: translateX(0px);
    transition: transform 0.2s ease;
    will-change: transform;
  }
}
.normal .button {
  background-color: $c-red;
  box-shadow: 0 0 0 rgba($c-red, 0.8);
  animation: pulse 2s infinite;

  &:before {
    transform: translateX(0px);
  }
}
.depressed .button {
  background-color: #535252;

  &:before {
    transform: translateX(20px);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/switch/SwitchButton.vue